// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false
import {post, fetch, patch, put} from './common/http'
import api from './common/api'
import util from './assets/js/util';
/* eslint-disable no-new */
Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$api = api;
Vue.prototype.$M = util;
import echarts from 'echarts';
import {Select,Option,Spin,Icon} from 'iview';
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Spin', Spin);
import 'iview/dist/styles/iview.css';
Vue.prototype.$echarts = echarts;
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
Vue.directive('title', {
    inserted: function (el, binding) {
        document.title = el.dataset.title
    }
})



// WEBPACK FOOTER //
// ./src/main.js